module.exports = __webpack_public_path__ + "img/loginImg.f0384719.jpg";